module.exports = __webpack_public_path__ + "static/media/caripill-micro.87e5fe60.png";